export default ['settlement', 'agricultural_purpose', 'industrial_purpose'];
